export default __webpack_public_path__ + "static/media/leavesIcon.e4d36f69.svg";